import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1220.70108,478.258262 C1250.97967,664.668368 1411.36786,807.38735 1606.29131,799.516523 L1606.29131,799.516523 L1606.29131,1602.66218 C1606.29131,1691.0082 1534.0082,1763.29131 1445.66218,1763.29131 L1445.66218,1763.29131 L160.629131,1763.29131 C72.2831088,1763.29131 0,1691.0082 0,1602.66218 L0,1602.66218 L0,638.887392 C0,550.54137 72.2831088,478.258262 160.629131,478.258262 L160.629131,478.258262 Z M1365.34761,791.509161 L1124.40392,791.509161 C991.563624,791.509161 883.460219,899.612566 883.460219,1032.45286 L883.460219,1032.45286 L883.460219,1193.08199 C883.460219,1325.92228 991.563624,1434.02568 1124.40392,1434.02568 L1124.40392,1434.02568 L1365.34761,1434.02568 L1365.34761,1273.39655 L1124.40392,1273.39655 C1080.15059,1273.39655 1044.08935,1237.33531 1044.08935,1193.08199 L1044.08935,1193.08199 L1044.08935,1032.45286 C1044.08935,988.199531 1080.15059,952.138292 1124.40392,952.138292 L1124.40392,952.138292 L1365.34761,952.138292 L1365.34761,791.509161 Z M722.831088,791.509161 L481.887392,791.509161 C349.047101,791.509161 240.943696,899.612566 240.943696,1032.45286 L240.943696,1032.45286 L240.943696,1193.08199 C240.943696,1325.92228 349.047101,1434.02568 481.887392,1434.02568 L481.887392,1434.02568 L722.831088,1434.02568 L722.831088,1273.39655 L481.887392,1273.39655 C437.634067,1273.39655 401.572827,1237.33531 401.572827,1193.08199 L401.572827,1193.08199 L401.572827,1032.45286 C401.572827,988.199531 437.634067,952.138292 481.887392,952.138292 L481.887392,952.138292 L722.831088,952.138292 L722.831088,791.509161 Z M1825.87133,157 L1920,251.208985 L1539.95148,631.257509 L1293.0645,384.370535 L1387.27349,290.241864 L1539.95148,442.919853 L1825.87133,157 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconClosedCaptioningOnLine = /*#__PURE__*/function (_Component) {
  _inherits(IconClosedCaptioningOnLine, _Component);

  var _super = _createSuper(IconClosedCaptioningOnLine);

  function IconClosedCaptioningOnLine() {
    _classCallCheck(this, IconClosedCaptioningOnLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconClosedCaptioningOnLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconClosedCaptioningOn",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconClosedCaptioningOnLine.displayName = "IconClosedCaptioningOnLine";
  return IconClosedCaptioningOnLine;
}(Component);

IconClosedCaptioningOnLine.glyphName = 'closed-captioning-on';
IconClosedCaptioningOnLine.variant = 'Line';
IconClosedCaptioningOnLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconClosedCaptioningOnLine;
export { IconClosedCaptioningOnLine };